import React from 'react';

import ViewAllContent from '../components/pages/waiting-area/sms-notification/content';

export const SmsNotificationCreateUpdatepage = (props) => {
  return (
    <div>
      <ViewAllContent updateOrInsert={props.updateOrInsert} />
    </div>
  );
};

export default SmsNotificationCreateUpdatepage;
